// from server to client
export const ClientEventType = {
  install: 'install',
  cacheDidUpdate: 'cacheDidUpdate',
  handlerDidComplete: 'handlerDidComplete',
  handlerDidError: 'handlerDidError',
  assets: 'assets',
} as const

export type ClientEventType = typeof ClientEventType[keyof typeof ClientEventType]

// from client to server
export const ServerEventType = {
  getAssets: 'getAssets',
  setLanguage: 'setLanguage',
} as const

export type ServerEventType = typeof ServerEventType[keyof typeof ServerEventType]

export type EventType = ClientEventType | ServerEventType

export type ClientEvent = {
  type: EventType
  data?: any
}
